module.exports = __webpack_public_path__ + "static/media/6.6576e034.jpg";